import { PlayIcon } from "@hugeicons-pro/core-stroke-rounded";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, ButtonSize } from "shared/components";
import { resumeApplicationApiCall } from "./api";

export const ResumeTooltip = ({
  title = "Resume the application to run reports",
  onSuccess,
  applicationId
}: {
  title?: string;
  onSuccess?: () => void | Promise<void>;
  applicationId: string | number;
}) => {
  const queryClient = useQueryClient();
  const { mutate: resumeApplication, isPending } = useMutation({
    mutationKey: ["APPLICATION", "RESUME", applicationId],
    mutationFn: () => {
      return resumeApplicationApiCall(applicationId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["APPLICATION_ID_REPORT"]
      });
      queryClient.invalidateQueries({
        queryKey: ["APPLICATION"]
      });
      queryClient.invalidateQueries({
        queryKey: ["REPORTS"]
      });
      queryClient.invalidateQueries({
        queryKey: ["CREDIT_REPORT"]
      });

      onSuccess?.();
    }
  });

  return (
    <div>
      <p className="mb-2.5">{title}</p>

      <Button
        size={ButtonSize.XS}
        HugeIcon={PlayIcon}
        className="bg-white hover:bg-background-900"
        loading={isPending}
        onClick={() => {
          resumeApplication();
        }}
      >
        Resume application
      </Button>
    </div>
  );
};
